import { IContactBase } from './contact-base.interface';
import { ISupplierBankAccount } from './supplier-bank-account.interface';

export interface ISupplier extends IContactBase {
  isWithHold: boolean;
  bankAccount: ISupplierBankAccount;
}
